export const POLICY_VERSION = '2026-04-15-v1';
